// extracted by mini-css-extract-plugin
module.exports = {"setupPage":"setup_setupPage__YaDIb","content":"setup_content__1eWKE"};